<template>
    <div>
        <!-- <div class="container mt-4 mb-2">
            <div class="row d-flex justify-content-center justify-content-md-start gap-1 gap-md-3">
                <div v-if="showWO" id="pedido-tour-desktop"  class="col-5 col-md-4 col-lg-2 text-center rounded bg-darkblue btn-insitu py-2 px-1 boton-titilante-staff-buttons">
                    <a id="boton-hacer-pedido" title="hacer pedido" class=" text-decoration-none text-white text-title-bat cursor-pointer" @click="trackingMakeAnOrder('makeAnOrder')">
                        <img class="img-menu-fixed" src="/img/icons/cart_new_look_white.svg" alt="Hacer pedido">
                        Hacer pedido
                    </a>
                </div>

                <div v-else  class="col-5 col-md-4 col-lg-2 text-center rounded bg-darkblue btn-insitu py-2 px-1 boton-titilante-staff-buttons">
                    <a class=" text-decoration-none text-white text-title-bat cursor-pointer" href="/retos">
                        <img class="img-menu-fixed" src="/img/icons/star.svg" alt="Gana Puntos">
                        Gana Puntos
                    </a>
                </div>

                <div id="canjea-home" class="col-5 col-md-4 col-lg-2 text-center bg-bat-blue rounded btn-popups py-2 px-1">
                    <a id="btn-canjea-home" title="Canjea" class=" text-decoration-none text-indigo  text-title-bat cursor-pointer" @click="trackingMakeAnOrder('Canjea')">
                        <img class="img-menu-fixed" src="/img/icons/canjea_blue_king.svg" alt="Canjea">
                        Canjea
                    </a>
                </div>
            </div>
        </div> -->

        <div class="container mt-1 mb-1" v-show="showWO !== null">
            <div class="insitu-buttons mb-2 d-flex justify-content-center justify-content-md-start">
                <a v-if="showWO" id="boton-hacer-pedido" title="hacer pedido" class="btn-place-order bg-darkblue btn-insitu py-3 px-1" @click="trackingMakeAnOrder('makeAnOrder')">
                    <img class="img-menu-fixed" src="/img/icons/cart_new_look_white.svg" alt="Hacer pedido" />
                    Hacer pedido
                </a>

                <a v-else class="btn-place-win-points bg-darkblue btn-insitu py-3 px-1" href="/retos">
                    <img class="img-menu-fixed" src="/img/icons/star.svg" alt="Gana Puntos" />
                    Gana Puntos
                </a>

                <a id="btn-canjea-home" title="Canjea" class="btn-redeem-home py-3 px-1" href="/catalogo">
                    <img class="img-menu-fixed" src="/img/icons/canjea_blue_king.svg" alt="Canjea" />
                    Canjea
                </a>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from './../../app';

    export default {
        props: {
            segments_staff: {
                default: null,
            },
            client_segment: {
                default: null,
            },
        },
        data() {
            return {
               showWO: null
            };
        },
        mounted() {
            this.getCheckSelectPDV();
            EventBus.$on('change-select-pdv', function (select_pdv) {
                this.getCheckSelectPDV()
            }.bind(this))
        },
        methods: {
            trackingMakeAnOrder(name){
                let log = 'Entered to place an order';

                if(name === 'myInvoices'){
                    log = 'Entered to my invoices';
                }
                axios.post('/trackingLog', {
                    logName: name,
                    log: log,
                }).then(
                    ({data}) => {
                        if(name !== 'makeAnOrder'){
                            window.location.href = "/orders/history";
                        }else{
                            window.location.href = "/pedidos";
                        }

                    })
            },

            getCheckSelectPDV() {
                axios.get(`/check-selected-pdv-token-wo`)
                    .then(({ data }) => {
                        this.showWO = data.token.success
                    })
                    .catch(error => {
                        console.error("Error al obtener los PDVs activos", error);
                        this.showWO = false;
                    });
            },
        }
    }
</script>

